module.exports = __webpack_public_path__ + "img/4-1.2a04882.png";